import type { PanelCatalog } from './en.js';

/** Arabic catalog for the web panels. Typed against the English reference catalog. */
export const ar: PanelCatalog = {
  common: {
    appTitleMerchant: 'لوحة التاجر',
    appTitleAdmin: 'إدارة المنصة',
    save: 'حفظ',
    saving: 'جارٍ الحفظ…',
    cancel: 'إلغاء',
    close: 'إغلاق',
    delete: 'حذف',
    edit: 'تعديل',
    create: 'إنشاء',
    add: 'إضافة',
    confirm: 'تأكيد',
    remove: 'إزالة',
    upload: 'رفع',
    replace: 'استبدال',
    search: 'بحث',
    refresh: 'تحديث',
    loading: 'جارٍ التحميل…',
    yes: 'نعم',
    no: 'لا',
    enabled: 'مفعّل',
    disabled: 'معطّل',
    on: 'تشغيل',
    off: 'إيقاف',
    never: 'أبدًا',
    none: 'لا يوجد',
    all: 'الكل',
    actions: 'إجراءات',
    status: 'الحالة',
    name: 'الاسم',
    email: 'البريد الإلكتروني',
    createdAt: 'تاريخ الإنشاء',
    updatedAt: 'آخر تحديث',
    previous: 'السابق',
    next: 'التالي',
    pageOf: 'صفحة {{page}} من {{pages}}',
    totalItems: '{{count}} عنصر',
    empty: 'لا يوجد شيء بعد.',
    saved: 'تم حفظ التغييرات.',
    deleted: 'تم الحذف.',
    copied: 'تم النسخ.',
    copy: 'نسخ',
    language: 'اللغة',
    arabic: 'العربية',
    english: 'English',
    theme: 'المظهر',
    signOut: 'تسجيل الخروج',
    unsavedChanges: 'لديك تغييرات غير محفوظة.',
    optional: 'اختياري',
    required: 'مطلوب',
    retry: 'إعادة المحاولة',
    areYouSure: 'هل أنت متأكد؟',
    cannotUndo: 'لا يمكن التراجع عن هذا الإجراء.',
    ms: '{{value}} ملّي ثانية',
    arabicText: 'النص العربي',
    englishText: 'النص الإنجليزي',
    more: 'المزيد',
    menu: 'القائمة',
    mainNavigation: 'التنقل الرئيسي',
    skipToContent: 'تخطَّ إلى المحتوى',
    themeSystem: 'حسب الجهاز',
    themeLight: 'فاتح',
    themeDark: 'داكن',
    clearSearch: 'مسح البحث',
  },
  nav: {
    dashboard: 'الرئيسية',
    hosts: 'سيرفرات IPTV',
    branding: 'الهوية والتصميم',
    featured: 'الأقسام المميزة',
    settings: 'إعدادات التطبيق',
    devices: 'الأجهزة',
    users: 'الفريق',
    audit: 'سجل النشاط',
    account: 'حسابي',
    tenants: 'التجار',
    plans: 'الباقات',
    releases: 'إصدارات التطبيق',
    globalSettings: 'الإعدادات العامة',
    announcements: 'الإعلانات',
    hostLibrary: 'مكتبة السيرفرات',
  },
  navShort: {
    dashboard: 'الرئيسية',
    hosts: 'السيرفرات',
    branding: 'الهوية',
    featured: 'المميزة',
    settings: 'الإعدادات',
    devices: 'الأجهزة',
    users: 'الفريق',
    audit: 'السجل',
    tenants: 'التجار',
    plans: 'الباقات',
    releases: 'الإصدارات',
    globalSettings: 'الإعدادات',
    announcements: 'الإعلانات',
    hostLibrary: 'السيرفرات',
  },
  auth: {
    signInTitle: 'تسجيل الدخول',
    signInSubtitleMerchant: 'أدر متجرك وسيرفراتك وعملاءك.',
    signInSubtitleAdmin: 'إدارة المنصة.',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    signIn: 'دخول',
    signingIn: 'جارٍ الدخول…',
    sessionExpired: 'انتهت جلستك. يرجى تسجيل الدخول مجددًا.',
    wrongPanel: 'لا يمكن لهذا الحساب استخدام هذه اللوحة.',
    changePassword: 'تغيير كلمة المرور',
    currentPassword: 'كلمة المرور الحالية',
    newPassword: 'كلمة المرور الجديدة',
    confirmPassword: 'تأكيد كلمة المرور الجديدة',
    passwordsDontMatch: 'كلمتا المرور غير متطابقتين.',
    passwordRules: '12 حرفًا على الأقل تتضمن حرفًا كبيرًا وحرفًا صغيرًا ورقمًا.',
    passwordChanged: 'تم تغيير كلمة المرور وتسجيل الخروج من الجلسات الأخرى.',
    profile: 'الملف الشخصي',
    role: 'الدور',
  },
  twoFactor: {
    title: 'التحقق بخطوتين',
    description: 'بعد كلمة المرور يطلب الدخول رمزًا من تطبيق المصادقة في جوالك.',
    on: 'مفعّل',
    off: 'غير مفعّل',
    turnOn: 'تفعيل',
    turnOff: 'إيقاف',
    turnedOff: 'تم إيقاف التحقق بخطوتين.',
    turnOffIntro: 'أدخل كلمة المرور ورمزًا حاليًا لإيقافه.',
    requiredNote: 'إلزامي لحسابك، لذلك لا يمكن إيقافه.',
    setupTitle: 'إعداد التحقق بخطوتين',
    setupRequired: 'هذا الحساب يجب أن يستخدم التحقق بخطوتين. يستغرق الإعداد دقيقة.',
    setupIntro:
      'أضف هذا الحساب إلى تطبيق مصادقة مثل Google Authenticator أو Microsoft Authenticator أو كلمات السر في الآيفون، ثم أدخل الرمز المكوّن من 6 أرقام الذي يظهر فيه.',
    openApp: 'إضافة إلى تطبيق المصادقة',
    qrLabel: 'رمز QR لتطبيق المصادقة',
    manualKey: 'أو أدخل هذا المفتاح في التطبيق',
    code: 'الرمز',
    codeHint: 'الرمز المكوّن من 6 أرقام من التطبيق، أو أحد رموزك الاحتياطية.',
    enterCode: 'أدخل الرمز المكوّن من 6 أرقام من تطبيق المصادقة.',
    verify: 'تحقق',
    back: 'رجوع',
    expired: 'انتهت مهلة الدخول. أدخل كلمة المرور مجددًا.',
    recoveryCodes: 'الرموز الاحتياطية',
    recoveryIntro: 'احفظها في مكان آمن. كل رمز يُدخلك مرة واحدة إذا ضاع جوالك.',
    recoveryWarning:
      'هذه المرة الوحيدة التي تظهر فيها هذه الرموز. احفظها الآن، فبدون جوالك أو رمز احتياطي لن تستطيع الدخول.',
    copyAll: 'نسخ الكل',
    download: 'تنزيل',
    savedCodes: 'حفظت الرموز',
    newCodes: 'رموز احتياطية جديدة',
    newCodesIntro: 'رموزك الاحتياطية القديمة ستتوقف. أدخل رمزًا حاليًا للمتابعة.',
    reset: 'إعادة ضبط التحقق بخطوتين',
    resetConfirm:
      'إعادة ضبط التحقق بخطوتين لـ {{name}}؟ سيُسجَّل خروجه من كل الأجهزة، ويعيد الإعداد عند دخوله القادم إذا كان إلزاميًا.',
    resetDone: 'تمت إعادة ضبط التحقق بخطوتين.',
  },
  roles: {
    SUPER_ADMIN: 'مدير المنصة',
    MERCHANT_OWNER: 'المالك',
    MERCHANT_ADMIN: 'مدير',
    MERCHANT_SUPPORT: 'دعم فني',
    VIEWER: 'مشاهد',
  },
  statuses: {
    ACTIVE: 'نشط',
    SUSPENDED: 'موقوف',
    DISABLED: 'معطّل',
    ARCHIVED: 'مؤرشف',
    BLOCKED: 'محظور',
    UNKNOWN: 'غير معروف',
    HEALTHY: 'سليم',
    DEGRADED: 'متذبذب',
    DOWN: 'متوقف',
  },
  platforms: {
    android_mobile: 'جوال أندرويد',
    android_tv: 'Android TV',
    fire_tv: 'Fire TV',
    ios: 'آيفون',
    ipados: 'آيباد',
    tvos: 'Apple TV',
    samsung_tv: 'تلفاز سامسونج',
    lg_tv: 'تلفاز إل جي',
  },
  channels: {
    play: 'Google Play',
    appstore: 'App Store',
    amazon: 'Amazon Appstore',
    direct_apk: 'تحميل APK مباشر',
  },
  features: {
    enableLive: 'البث المباشر',
    enableMovies: 'الأفلام',
    enableSeries: 'المسلسلات',
    enableEPG: 'دليل البرامج (EPG)',
    enableFavorites: 'المفضلة',
    enableContinueWatching: 'متابعة المشاهدة',
    enableSearch: 'البحث',
    enableSupport: 'شاشة الدعم',
    enableExternalPlayer: 'مشغل خارجي',
    enableParentalControls: 'الرقابة الأبوية',
    enableMultiProfile: 'ملفات شخصية متعددة',
  },
  dashboard: {
    title: 'الرئيسية',
    storeCode: 'كود المتجر',
    storeCodeHint: 'يُدخل العميل هذا الكود مرة واحدة في التطبيق لتحميل متجرك.',
    plan: 'الباقة',
    expires: 'ينتهي الاشتراك',
    noExpiry: 'بدون تاريخ انتهاء',
    hosts: 'السيرفرات',
    limitOf: '{{used}} من {{limit}}',
    noHostsWarning: 'أضف سيرفر IPTV واحدًا على الأقل ليتمكن العملاء من الدخول.',
    addHost: 'إضافة سيرفر',
  },
  hosts: {
    title: 'سيرفرات IPTV',
    subtitle:
      'تُخزَّن السيرفرات مشفّرة ولا تظهر للعملاء أبدًا. يختار التطبيق السيرفر الأساسي وينتقل للاحتياطي تلقائيًا عند العطل.',
    add: 'إضافة سيرفر',
    editTitle: 'تعديل السيرفر',
    createTitle: 'سيرفر جديد',
    label: 'الاسم',
    labelHint: 'لفريقك فقط، مثل "السيرفر الرئيسي".',
    url: 'رابط السيرفر',
    urlHint: 'العنوان الأساسي الذي أعطاك إياه المزوّد، مثل https://panel.example.com:8443',
    urlKeep: 'اتركه فارغًا للإبقاء على العنوان الحالي.',
    providerKind: 'نوع المزوّد',
    xtream: 'متوافق مع Xtream',
    role: 'الدور',
    PRIMARY: 'أساسي',
    BACKUP: 'احتياطي',
    priority: 'الأولوية',
    priorityHint: 'الأرقام الأقل تُجرَّب أولًا بين السيرفرات من نفس الدور.',
    enabled: 'مفعّل',
    health: 'الحالة الصحية',
    latency: 'زمن الاستجابة',
    subscribers: 'المشتركون',
    subscribersOnline: '{{count}} الآن',
    subscribersToday: '{{count}} اليوم',
    subscribersDetail: '{{today}} اليوم · {{signedIn}} مسجّلون',
    subscribersHint:
      'من يستخدم هذا السيرفر الآن (آخر 5 دقائق) واليوم، وكم مشتركًا مسجّل دخوله عليه. ينتقل المشترك تلقائيًا لسيرفر آخر عند العطل.',
    monitorTitle: 'حسابات الفحص',
    monitorIntro:
      'حساب مشترك لكل مزود يُفحص به كل سيرفر من سيرفراته كل 5 دقائق. السيرفر اللي يفشل 15 دقيقة وغيره من نفس المزود شغّال يتوقف، ويرجع لوحده إذا اشتغل، وبعد 3 أيام متوقف يُحذف. الحساب يُحفظ مشفّراً.',
    monitorChecked: 'آخر فحص {{when}}',
    monitorRejected:
      'كل السيرفرات رفضت هذا الحساب، فهو منتهي أو غير صحيح. ما يتوقف أي سيرفر حتى تحدّثه.',
    monitorUsername: 'اسم المستخدم',
    monitorPassword: 'كلمة المرور',
    monitorSave: 'حفظ وفحص الآن',
    monitorChange: 'تغيير الحساب',
    monitorRemove: 'حذف الحساب',
    monitorRemoveConfirm:
      'حذف حساب الفحص؟ تبقى السيرفرات كما هي ولا يتوقف أو يُحذف أي منها تلقائياً.',
    monitorRecent: 'آخر 7 أيام',
    provider: 'المزوّد',
    providerHint: 'سيرفرات المزوّد الواحد تُفحص بحسابه وتُقارن ببعضها فقط.',
    noProvider: 'بدون مزوّد',
    allHosts: 'كل السيرفرات',
    hostCount: '{{count}} سيرفر',
    addProvider: 'إضافة مزوّد',
    providerName: 'اسم المزوّد',
    renameProvider: 'تعديل الاسم',
    deleteProvider: 'حذف المزوّد',
    deleteProviderConfirm:
      'حذف المزوّد "{{name}}"؟ تبقى سيرفراته وتُفحص بحساب السيرفرات بدون مزوّد.',
    loginNone: 'بدون حساب',
    loginRefused: 'مرفوض',
    setLogin: 'حفظ حساب',
    providerHosts: 'السيرفرات',
    providerHostsTitle: 'سيرفرات {{name}}',
    providerHostsIntro:
      'حدّد سيرفرات هذا المزوّد. المحدد يُنقل إليه، والذي تلغي تحديده يرجع بدون مزوّد. لا يتغير شيء على المشتركين.',
    selectLoose: 'تحديد كل السيرفرات بدون مزوّد',
    selectNone: 'إلغاء التحديد',
    currentlyIn: 'حالياً: {{name}}',
    selectedCount: '{{count}} محدد',
    auto_disabled: 'أُوقف تلقائياً',
    auto_enabled: 'رجع تلقائياً',
    auto_deleted: 'حُذف تلقائياً',
    autoDisabled: 'موقوف تلقائياً',
    failingSince: 'بدأ يفشل {{when}}',
    lastChecked: 'آخر فحص',
    test: 'اختبار الاتصال',
    testing: 'جارٍ الاختبار…',
    testOk: 'السيرفر متاح خلال {{ms}} ملّي ثانية.',
    testFailed: 'فشل فحص السيرفر: {{reason}}.',
    testTitle: 'اختبار "{{label}}"',
    testIntro:
      'اتركه فارغاً ليُفحص بحساب الفحص المحفوظ لمزوّده، أو اكتب حساب مشترك لهذا الفحص فقط (لا يُحفظ).',
    testUsername: 'اسم مستخدم المشترك (اختياري)',
    testPassword: 'كلمة مرور المشترك (اختياري)',
    runTest: 'ابدأ الفحص',
    testOkAccount: 'السيرفر يعمل ({{ms}} ملّي ثانية)، لكن هذا الحساب {{reason}}.',
    deleteConfirm: 'حذف السيرفر "{{label}}"؟ سينتقل العملاء عليه إلى سيرفر آخر.',
    empty: 'لا توجد سيرفرات بعد. أضف عنوان السيرفر الذي أعطاك إياه المزوّد.',
    history: 'آخر الفحوصات',
    limitReached: 'باقتك تسمح بـ {{limit}} سيرفرات.',
    honestNote:
      'إخفاء السيرفر يجعل الوصول إليه صعبًا لا مستحيلًا: يستطيع مستخدم متمرس يملك أدوات شبكة على جهازه مراقبة الاتصال. الوضع المحمي يضيف بوابة أمام البث.',
    addMany: 'إضافة عدة سيرفرات',
    addManyTitle: 'إضافة عدة سيرفرات',
    addManyIntro:
      'الصق روابط مزوّد واحد، كل رابط في سطر. تعمل كسيرفر واحد: إذا انحظر أحدها أو توقف ينتقل العملاء تلقائيًا إلى التالي.',
    links: 'الروابط',
    linksHint: 'روابط M3U الكاملة تعمل أيضًا: يُحفظ عنوان السيرفر فقط.',
    linksCount: '{{count}} روابط',
    namePrefix: 'الاسم',
    namePrefixHint: 'تُسمّى السيرفرات "{{label}} 1" و"{{label}} 2" وهكذا.',
    namePrefixDefault: 'سيرفر',
    testAccountIntro:
      'اتركه فارغاً ليُفحص بحساب الفحص المحفوظ للمزوّد المختار، أو اكتب حساب مشترك لهذا الاختبار فقط (لا يُحفظ).',
    testLinks: 'اختبار الروابط',
    testAgain: 'اختبار مرة أخرى',
    addWorking: 'إضافة الشغّالة ({{count}})',
    addFastest: 'إضافة أسرع {{count}}',
    roomLeft: 'باقتك تسمح بـ {{limit}} سيرفرات، فيمكنك إضافة {{room}} أخرى.',
    noRoom: 'باقتك تسمح بـ {{limit}} سيرفرات وكلها مستخدمة. احذف سيرفرًا لتضيف غيره.',
    added: 'أُضيفت {{count}} سيرفرات.',
    link: 'الرابط',
    result: 'النتيجة',
    works: 'شغّال',
    worksIn: 'شغّال · {{ms}} ملّي ثانية',
    failed: 'فشل',
    existing: 'مضاف من قبل',
    repeated: 'مكرر في الأعلى',
    testAll: 'اختبار الكل',
    testAllTitle: 'اختبار كل السيرفرات',
    testAllIntro:
      'اتركه فارغاً ليُفحص كل سيرفر بحساب الفحص المحفوظ لمزوّده، أو اكتب حساب مشترك لهذا الاختبار فقط (لا يُحفظ).',
    deleteFailed: 'حذف الفاشلة ({{count}})',
    deleteFailedConfirm: 'حذف {{count}} سيرفرات فشلت في الاختبار؟ ينتقل العملاء إلى الشغّالة.',
    allWork: 'كل السيرفرات شغّالة.',
  },
  hostCheck: {
    open: 'فحص من السعودية',
    title: 'فحص السيرفرات من بلد المشتركين',
    intro:
      'سيرفرنا يفحص من أوروبا، فالسيرفر المحجوب في السعودية يظهر هنا شغّال. أعطِ هذا الرابط لموظف داخل السعودية: يفتحه من جواله فيُفحص كل سيرفر من شبكته، وتظهر النتيجة هنا بجانب كل سيرفر.',
    unavailable: 'رابط الفحص غير مفعّل على المنصة بعد.',
    create: 'إنشاء الرابط',
    created: 'أُنشئ {{when}}',
    howTo:
      'يفتحه الموظف كما هو (يبدأ بـ http://) من شبكة الجوال أو الواي فاي بدون VPN، ثم يضغط "ابدأ الفحص". الأفضل من آيفون: يقدر يجرب تشغيل قناة. يحفظ يوزر لكل مزوّد مرة وحدة على جواله.',
    secret:
      'من معه الرابط يرى عناوين سيرفراتك وحسابات الفحص المحفوظة. أعطه لمن تثق به فقط، وجدّده إذا وصل لغيره.',
    renew: 'تجديد الرابط',
    renewConfirm: 'تجديد الرابط؟ يتوقف الرابط القديم فورًا.',
    delete: 'حذف الرابط',
    deleteConfirm: 'حذف رابط الفحص؟ يتوقف فورًا، وتبقى آخر النتائج ظاهرة.',
    badge: 'السعودية: {{verdict}}',
    WORKS: 'يعمل',
    BLOCKED: 'محجوب',
    DOWN: 'متوقف',
    NO_PLAYBACK: 'لم يشتغل البث',
    UNCONFIRMED: 'غير مؤكد',
    hint_WORKS: 'وصل جوال الموظف للسيرفر نفسه',
    hint_BLOCKED: 'شغّال من سيرفرنا، لكن شبكة الموظف لا توصله أو ترد بدلًا منه',
    hint_DOWN: 'لا يرد على جوال الموظف ولا على سيرفرنا',
    hint_NO_PLAYBACK: 'يرد، لكن قناة تجريبية لم تشتغل على جوال الموظف',
    hint_UNCONFIRMED: 'وصل رد، لكن المتصفح لم يستطع التأكد أنه من السيرفر؛ افحصه من آيفون',
  },
  hostReasons: {
    INVALID_URL: 'ليس رابطًا صحيحًا',
    NETWORK: 'تعذّر الاتصال',
    TIMEOUT: 'لا يوجد رد في الوقت المحدد',
    BAD_RESPONSE: 'رد غير متوقع، تحقق من العنوان',
    UPSTREAM_ERROR: 'السيرفر أعاد خطأ',
    INVALID_CREDENTIALS: 'بيانات الدخول مرفوضة',
    ACCOUNT_EXPIRED: 'الحساب منتهي',
    ACCOUNT_DISABLED: 'الحساب معطّل',
    NOT_FOUND: 'غير موجود، تحقق من العنوان',
    BLOCKED_DESTINATION: 'العناوين الخاصة أو المحلية غير مسموحة',
    NEEDS_ACCOUNT: 'السيرفر يرد لكنه يخفي نفسه عن الفحص بدون حساب، افحصه باسم مستخدم مشترك',
  },
  branding: {
    title: 'الهوية والتصميم',
    subtitle: 'شكل متجرك داخل التطبيق. تصل التغييرات للعملاء عند فتح التطبيق التالي.',
    identity: 'الهوية',
    storeName: 'اسم المتجر',
    appName: 'اسم التطبيق',
    colors: 'الألوان',
    primary: 'الأساسي',
    secondary: 'الثانوي',
    accent: 'اللون المميز',
    background: 'الخلفية',
    surface: 'الأسطح',
    onPrimary: 'النص فوق الأساسي',
    text: 'النص',
    buttonStyle: 'شكل الأزرار',
    ROUNDED: 'دائري الحواف',
    PILL: 'كبسولة',
    SQUARE: 'مربّع',
    assets: 'الصور',
    logo: 'الشعار',
    splash: 'شاشة البداية',
    background_img: 'خلفية الرئيسية',
    loginBackground: 'خلفية تسجيل الدخول',
    assetHint: 'PNG أو JPEG أو WebP حتى 5 ميجابايت.',
    assetTooLarge: 'حجم الملف أكبر من 5 ميجابايت.',
    assetWrongType: 'استخدم صورة PNG أو JPEG أو WebP.',
    support: 'بيانات الدعم',
    phone: 'الهاتف',
    whatsapp: 'واتساب',
    telegram: 'تيليجرام',
    website: 'الموقع',
    termsUrl: 'رابط شروط الاستخدام',
    privacyUrl: 'رابط سياسة الخصوصية',
    messages: 'الرسائل',
    welcome: 'رسالة الترحيب',
    loginHint: 'تلميح شاشة الدخول',
    emptyState: 'رسالة المحتوى الفارغ',
    maintenance: 'رسالة الصيانة',
    preview: 'معاينة',
    previewLogin: 'شاشة الدخول',
    previewUsername: 'اسم المستخدم',
    previewPassword: 'كلمة المرور',
    previewSignIn: 'دخول',
    fullBrandingLocked:
      'باقتك تتضمن هوية أساسية. قم بالترقية لتخصيص شكل الأزرار والرسائل والصور الإضافية.',
  },
  settings: {
    title: 'إعدادات التطبيق',
    playback: 'التشغيل',
    mediaMode: 'طريقة توصيل البث',
    DIRECT: 'مباشر',
    DIRECT_hint: 'يشغّل التطبيق البث مباشرة من السيرفر. الأسرع، لكن عنوان البث يصل للجهاز.',
    GATEWAY: 'بوابة محمية',
    GATEWAY_hint:
      'يمر البث عبر روابط موقّعة قصيرة العمر من بوابتنا. لا يُرسَل عنوان السيرفر إلى الجهاز.',
    gatewayLocked: 'البوابة المحمية غير متاحة في باقتك.',
    autoPlayNext: 'تشغيل الحلقة التالية تلقائيًا',
    language: 'لغة التطبيق الافتراضية',
    maintenance: 'وضع الصيانة',
    maintenanceHint: 'يرى العملاء رسالة الصيانة بدل المحتوى.',
    maintenanceMessage: 'رسالة الصيانة',
    expiryReminder: 'تنبيه قرب انتهاء الاشتراك',
    expiryReminderHint: 'يظهر في رئيسية التطبيق للعميل اللي قرب ينتهي اشتراكه عند المزوّد.',
    expiryReminderEnabled: 'نبّه العملاء قبل انتهاء اشتراكهم',
    expiryDaysBefore: 'ابدأ التنبيه قبل الانتهاء بـ (أيام)',
    expiryDaysPreset: 'قبل {{count}} يوم',
    expiryMessage: 'نص التنبيه',
    expiryMessageHint:
      'اكتب {days} مكان عدد الأيام الباقية. إذا تركته فاضي يستخدم التطبيق نصه الافتراضي.',
    expiryPreview: 'كذا يشوفه العميل لو باقي {{days}} أيام:',
    expiryDefaultMessage:
      'باقي على اشتراكك {days} أيام. راجع متجرك للتجديد عشان ما تنقطع عليك الخدمة.',
    features: 'الميزات',
    featuresHint: 'فعّل أو عطّل أقسام التطبيق. الميزات غير المتاحة في باقتك لا يمكن تفعيلها.',
    notInPlan: 'غير متاحة في الباقة',
    parental: 'الرقابة الأبوية',
    parentalEnabled: 'السماح للعملاء بقفل الأقسام برمز PIN',
    hideAdult: 'إخفاء الأقسام التي يصنفها المزوّد للبالغين',
    minVersions: 'أدنى إصدار للتطبيق',
    minVersionsHint: 'يُطلب من العملاء الأقدم من هذا الإصدار التحديث اختياريًا أو إجباريًا.',
    minimumVersion: 'أدنى إصدار',
    updateType: 'نوع التحديث',
    OPTIONAL: 'اختياري',
    REQUIRED: 'إجباري',
    noMinimum: 'بدون حد أدنى',
  },
  devices: {
    title: 'الأجهزة',
    subtitle: 'الأجهزة التي سجّل منها عملاؤك الدخول.',
    searchPlaceholder: 'ابحث باسم المستخدم أو اسم الجهاز',
    customer: 'العميل',
    device: 'الجهاز',
    platform: 'المنصة',
    appVersion: 'إصدار التطبيق',
    lastActivity: 'آخر نشاط',
    sessions: 'الجلسات',
    logout: 'تسجيل خروج الجهاز',
    block: 'حظر',
    unblock: 'إلغاء الحظر',
    logoutConfirm: 'تسجيل الخروج من كل الجلسات على هذا الجهاز؟',
    blockConfirm: 'حظر هذا الجهاز؟ سيتم تسجيل خروجه ولن يتمكن من الدخول حتى يُلغى الحظر.',
    loggedOut: 'تم تسجيل خروج الجهاز.',
    blocked: 'تم حظر الجهاز.',
    unblocked: 'تم إلغاء حظر الجهاز.',
    anyStatus: 'أي حالة',
    anyPlatform: 'أي منصة',
  },
  users: {
    title: 'الفريق',
    subtitle: 'الأشخاص الذين يمكنهم الدخول إلى هذه اللوحة.',
    add: 'إضافة عضو',
    createTitle: 'عضو جديد',
    editTitle: 'تعديل العضو',
    displayName: 'الاسم',
    initialPassword: 'كلمة المرور الأولية',
    initialPasswordHint: 'شاركها بشكل خاص. يمكنه تغييرها من صفحة حسابي.',
    lastLogin: 'آخر دخول',
    deleteConfirm: 'إزالة {{name}} من الفريق؟',
    you: 'أنت',
    limitReached: 'باقتك تسمح بـ {{limit}} أعضاء.',
  },
  audit: {
    title: 'سجل النشاط',
    subtitle: 'سجل بالتغييرات التي تمت على هذا الحساب.',
    when: 'الوقت',
    actor: 'المنفّذ',
    action: 'الإجراء',
    target: 'الهدف',
    ip: 'IP',
    details: 'التفاصيل',
    filterAction: 'تصفية حسب الإجراء',
    USER: 'عضو فريق',
    CUSTOMER: 'عميل',
    SYSTEM: 'النظام',
  },
  tenants: {
    title: 'التجار',
    add: 'تاجر جديد',
    createTitle: 'تاجر جديد',
    editTitle: 'تعديل التاجر',
    searchPlaceholder: 'ابحث بالاسم أو كود المتجر',
    name: 'اسم التاجر',
    plan: 'الباقة',
    storeCode: 'كود المتجر',
    storeCodeHint: 'اتركه فارغًا لتوليده تلقائيًا. من 4 إلى 16 حرفًا أو رقمًا.',
    expiresAt: 'ينتهي الاشتراك',
    maxDevicesOverride: 'تجاوز حد الأجهزة',
    maxUsersOverride: 'تجاوز حد الفريق',
    overrideHint: 'اتركه فارغًا لاستخدام حد الباقة.',
    notes: 'ملاحظات داخلية',
    owner: 'حساب المالك',
    ownerName: 'اسم المالك',
    ownerEmail: 'بريد المالك',
    ownerPassword: 'كلمة مرور المالك الأولية',
    created: 'تم إنشاء التاجر. كود المتجر: {{code}}',
    suspend: 'إيقاف',
    activate: 'تفعيل',
    disable: 'تعطيل',
    archive: 'أرشفة',
    archiveConfirm: 'أرشفة {{name}}؟ سيتوقف كود المتجر وتنتهي كل الجلسات.',
    statusReason: 'السبب (اختياري)',
    statusConfirm: 'تغيير حالة {{name}} إلى {{status}}؟',
    resetCode: 'إعادة تعيين كود المتجر',
    resetCodeConfirm:
      'إعادة تعيين كود المتجر لـ {{name}}؟ العملاء الذين لم يفتحوا التطبيق بعد سيحتاجون الكود الجديد. العملاء المسجلون لا يتأثرون.',
    newCode: 'كود المتجر الجديد: {{code}}',
    customCode: 'كود مخصص (اختياري)',
    featureOverrides: 'تجاوز الميزات',
    panelSecurity: 'الدخول إلى اللوحة',
    panelSecurityHint: 'الأشخاص الذين يستطيعون الدخول إلى لوحة هذا المتجر.',
    requireTwoFactor: 'إلزام التحقق بخطوتين',
    requireTwoFactorHint: 'كل من لم يفعّله يجب أن يعدّه عند دخوله القادم.',
    isTest: 'متجر تجريبي',
    isTestHint: 'للعرض والتجربة. مشتركوه لا يُحسبون في أرقام المنصة في النظرة العامة.',
    featureOverridesHint: 'تجاوز إعدادات الباقة لهذا التاجر. "افتراضي الباقة" يزيل التجاوز.',
    planDefault: 'افتراضي الباقة',
    forceOn: 'تفعيل إجباري',
    forceOff: 'تعطيل إجباري',
    details: 'التفاصيل',
  },
  plans: {
    title: 'الباقات',
    add: 'باقة جديدة',
    createTitle: 'باقة جديدة',
    editTitle: 'تعديل الباقة',
    code: 'الرمز',
    codeHint: 'أحرف إنجليزية صغيرة وأرقام و - و _.',
    maxDevices: 'أقصى عدد أجهزة',
    maxMerchantUsers: 'أقصى عدد أعضاء',
    maxHosts: 'أقصى عدد سيرفرات',
    apiRateLimitPerMinute: 'طلبات API في الدقيقة',
    fullBranding: 'هوية كاملة',
    analytics: 'التحليلات',
    gatewayMode: 'البوابة المحمية',
    active: 'نشطة',
    limits: 'الحدود',
    capabilities: 'القدرات',
    features: 'الميزات المضمّنة',
  },
  releases: {
    title: 'إصدارات التطبيق',
    subtitle: 'انشر إصدارًا واحدًا لكل الأجهزة مرة واحدة، والتطبيقات تعرض التحديث بنفسها.',
    add: 'نشر إصدار',
    editTitle: 'تعديل الإصدار',
    group: { android: 'أندرويد', apple: 'أبل' },
    notPublished: 'لم يُنشر بعد',
    publishHere: 'نشر',
    requiredBadge: 'تحديث إجباري',
    minimumBadge: 'الحد الأدنى {{version}}',
    devices: 'الأجهزة',
    none: 'لا يوجد',
    version: 'رقم الإصدار',
    currentlyOn: 'الأجهزة المختارة على {{version}}',
    versionDown: 'رقم الإصدار السابق',
    versionUp: 'رقم الإصدار التالي',
    belowCurrent: '{{platform}} عليه الإصدار {{version}} أصلًا.',
    required: 'تحديث إجباري',
    requiredHint: 'الإصدارات الأقدم لازم تتحدث قبل المشاهدة.',
    publishTo: 'نشر للمحدد ({{count}})',
    publishedTo: 'تم النشر. الأجهزة المحدّثة: {{count}}',
    sourceLatest: 'آخر نسخة على GitHub:',
    sourceUse: 'استخدمها',
    sourceApplied: 'تمت التعبئة',
    sourceUnavailable: 'تعذر الوصول إلى GitHub. أدخل الرابط بنفسك.',
    latestVersion: 'أحدث إصدار',
    minimumVersion: 'أدنى إصدار',
    blockedVersions: 'إصدارات محظورة',
    blockedVersionsHint: 'مفصولة بفواصل، مثل 1.0.3, 1.0.4',
    releaseNotes: 'ملاحظات الإصدار',
    downloadUrl: 'رابط تحميل APK',
    storeUrl: 'رابط المتجر',
    sha256: 'بصمة SHA-256',
    fileSize: 'حجم الملف (بايت)',
  },
  featured: {
    title: 'الأقسام المميزة',
    subtitle:
      'شعارات دائرية في أعلى الصفحة الرئيسية للتطبيق. كل شعار يفتح أقسام المزود التي تختارها، مثل قسم نتفليكس أو الأطفال.',
    add: 'إضافة قسم',
    empty: 'لا توجد أقسام مميزة بعد. أضف قسمًا ليصل المشتركون بسرعة لأكثر ما يشاهدونه.',
    emptyTitle: 'أبرز أفضل محتواك',
    newTitle: 'قسم مميز جديد',
    editTitle: 'تعديل {{name}}',
    name: 'الاسم',
    namePlaceholder: 'أطفال',
    logo: 'الشعار',
    logoHint: 'صورة مربعة PNG أو JPG أو WebP حتى 2 ميجابايت. تظهر داخل دائرة.',
    logoWrongType: 'اختر صورة PNG أو JPG أو WebP.',
    logoTooLarge: 'يجب ألا يتجاوز حجم الشعار 2 ميجابايت.',
    shown: 'ظاهر في التطبيق',
    hidden: 'مخفي',
    categories: 'الأقسام',
    categoryCount: 'عدد الأقسام: {{count}}',
    noCategories: 'اختر قسمًا واحدًا على الأقل من الأسفل.',
    pickTitle: 'اختيار الأقسام',
    pickIntro: 'أدخل حساب مشترك في هذا المتجر لعرض أقسام المزود. يُستخدم مرة واحدة ولا يُحفظ.',
    username: 'اسم مستخدم المشترك',
    password: 'كلمة مرور المشترك',
    load: 'عرض الأقسام',
    reload: 'تحميل من جديد',
    filter: 'تصفية الأقسام',
    noMatch: 'لا يوجد قسم مطابق.',
    sectionLive: 'مباشر',
    sectionMovie: 'أفلام',
    sectionSeries: 'مسلسلات',
    tooMany: 'يمكن أن يضم القسم حتى {{max}} قسمًا.',
    INVALID_CREDENTIALS: 'رفض المزود اسم المستخدم أو كلمة المرور.',
    ACCOUNT_EXPIRED: 'انتهى هذا الاشتراك. استخدم حسابًا فعالًا.',
    ACCOUNT_DISABLED: 'هذا الحساب موقوف. استخدم حسابًا فعالًا.',
    moveUp: 'تحريك {{name}} للأعلى',
    moveDown: 'تحريك {{name}} للأسفل',
    drag: 'اسحب لتغيير الترتيب',
    reordered: 'تم حفظ الترتيب',
    deleteConfirm: 'حذف القسم {{name}}؟',
    created: 'تمت إضافة القسم',
    limit: 'حتى {{max}} قسمًا.',
  },
  pilot: {
    waitingTitle: 'النسخة {{version}} بانتظار تجربتك',
    waitingIntro: 'تصل الآن لحسابات التجربة فقط. ثبّتها على جهازك وجرّبها، ثم أرسلها للجميع.',
    testedOn: 'أجهزة التجربة التي تعمل عليها: {{count}}',
    notTestedYet: 'لم تُثبّت على جهاز تجربة بعد',
    built: 'بُنيت {{when}}',
    sendAll: 'أرسلها للجميع',
    sendTitle: 'إرسال {{version}} للجميع',
    sendIntro: 'كل جوالات أندرويد وشاشات Android TV وFire TV يظهر لها هذا التحديث.',
    sendUntested: 'لا يوجد جهاز تجربة يعمل على هذه النسخة بعد.',
    sent: 'النسخة {{version}} في طريقها لكل الأجهزة.',
    skip: 'تجاهل',
    skipConfirm: 'تجاهل النسخة {{version}}؟ لن تصل لأحد غير حسابات التجربة.',
    skipped: 'تم التجاهل. الأجهزة تبقى على النسخة الحالية.',
    testersTitle: 'حسابات التجربة',
    testersIntro: 'الأجهزة المسجّلة بهذه الحسابات تصلها كل نسخة جديدة قبل الجميع.',
    store: 'المتجر',
    username: 'اسم مستخدم المشترك',
    noDevices: 'لا يوجد جهاز مسجّل بعد',
    testerAdded: 'تمت إضافة حساب التجربة.',
    removeConfirm: 'إيقاف إرسال النسخ الجديدة مبكرًا إلى {{name}}؟',
    linkTitle: 'رابط التحميل',
    linkIntro:
      'يحمّل دائمًا النسخة التي أرسلتها للجميع. استخدمه في تطبيق Downloader وفي التعليمات.',
    copyLink: 'نسخ الرابط',
  },
  tvRelease: {
    title: 'أجهزة تلفاز سامسونج وإل جي',
    intro: 'يحمّل التلفاز النسخة الجديدة عند فتح التطبيق في المرة القادمة، دون مراجعة من المتجر.',
    runningNow: 'النسخة على أجهزة التلفاز الآن',
    noneYet: 'لا يوجد بعد: يعمل التلفاز بالنسخة المضمّنة في التطبيق المثبّت',
    waitingTitle: 'النسخة {{version}} بانتظار تجربتك',
    waitingIntro:
      'تصل فقط لأجهزة التلفاز المسجّلة بحسابات التجربة (نفس حسابات أندرويد). افتح التطبيق على أحدها وجرّبها، ثم أرسلها للجميع.',
    testedOn: 'أجهزة تلفاز التجربة التي تعمل عليها: {{count}}',
    notTestedYet: 'لم تعمل على تلفاز تجربة بعد',
    sendConfirm:
      'إرسال النسخة {{version}} لكل أجهزة تلفاز سامسونج وإل جي؟ ينتقل كل جهاز إليها عند فتح التطبيق في المرة القادمة.',
    sendConfirmUntested:
      'لا يوجد تلفاز تجربة يعمل على النسخة {{version}} بعد. إرسالها لكل أجهزة تلفاز سامسونج وإل جي على أي حال؟',
    sent: 'النسخة {{version}} تصل لكل أجهزة التلفاز عند فتح التطبيق في المرة القادمة.',
    skipConfirm: 'تجاهل النسخة {{version}}؟ لن تصل لأي تلفاز آخر.',
    skipped: 'تم التجاهل. أجهزة التلفاز تبقى على النسخة الحالية.',
  },
  globalSettings: {
    title: 'الإعدادات العامة',
    maintenance: 'صيانة المنصة',
    maintenanceHint: 'تعرض كل التطبيقات رسالة الصيانة. تبقى اللوحات متاحة.',
    features: 'مفاتيح الميزات العامة',
    featuresHint: 'الميزة المعطّلة هنا تتعطل لكل التجار.',
  },
  hostLibrary: {
    title: 'مكتبة السيرفرات',
    subtitle:
      'كل السيرفرات التي حفظها تجارك تحت مزوّد، مجمّعة حسب اسم المزوّد. أرسل السيرفرات الشغالة لأي تاجر: يأخذ نسخة خاصة به تُفحص بحسابه، ولا يعرف من أين جاءت.',
    empty: 'لا توجد سيرفرات بعد. تظهر هنا عندما يحفظ تاجر سيرفرات تحت مزوّد.',
    workingOf: '{{working}} شغال من {{total}}',
    storeCount: 'عند {{count}} متجر',
    hostCount: 'سيرفرات: {{count}}',
    linkedIntro: 'هؤلاء التجار تصلهم سيرفرات هذا المزوّد الشغالة الجديدة تلقائياً:',
    unlink: 'إيقاف الإرسال إلى {{name}}',
    unlinkAction: 'إيقاف الإرسال',
    unlinkConfirm:
      'إيقاف إرسال سيرفرات {{provider}} الجديدة إلى {{name}}؟ السيرفرات الموجودة عنده تبقى.',
    unlinked: 'لن تُرسل سيرفرات جديدة لهذا التاجر',
    pickWorking: 'تحديد الشغالة',
    pickNone: 'إلغاء التحديد',
    sendAll: 'إرسال إلى تاجر',
    sendPicked: 'إرسال المحدد ({{count}})',
    sendTitle: 'إرسال سيرفرات {{name}}',
    sendAllIntro:
      'يأخذ التاجر سيرفرات {{name}} الشغالة غير الموجودة عنده ({{count}})، ويبقى مرتبطاً: أي سيرفر يشتغل لاحقاً يصله تلقائياً.',
    sendPickedIntro: 'يأخذ التاجر السيرفرات المحددة غير الموجودة عنده ({{count}})، مرة واحدة.',
    noneWorking: 'لا يوجد سيرفر شغال لهذا المزوّد الآن. حدّد السيرفرات التي تريد إرسالها.',
    store: 'التاجر',
    pickStore: 'اختر تاجراً',
    send: 'إرسال',
    resultAdded: 'أُضيف {{count}}',
    resultExisting: 'موجود مسبقاً: {{count}}',
    resultOverLimit: 'لم يُضف {{count}}: باقة التاجر ممتلئة',
    upload: 'رابط إضافة سيرفرات',
    uploadTitle: 'إضافة سيرفرات جديدة من السعودية',
    uploadIntro:
      'رابط خاص لك: تفتحه من جوالك داخل السعودية، تكتب المزوّد واليوزر والسيرفرات الجديدة، فيُفحص كل سيرفر من شبكتك قبل ما يوصل لأي مشترك، ثم ترفع الشغالة بزر واحد.',
    uploadStoreIntro:
      'تُضاف السيرفرات إلى هذا المتجر تحت مزوّدها، فيفحصها سيرفرنا باستمرار، ومن هنا توصل تلقائياً لكل تاجر مرتبط بالمزوّد.',
    uploadStore: 'المتجر الذي تُضاف إليه',
    uploadCreate: 'إنشاء الرابط',
    uploadFor: 'يضيف إلى متجر {{name}} · أُنشئ {{when}}',
    uploadSecret: 'من معه هذا الرابط يقدر يضيف سيرفرات. لا تعطه لأحد، وجدّده إذا وصل لغيرك.',
    uploadRenewConfirm: 'إنشاء رابط جديد؟ يتوقف الرابط القديم فوراً.',
    uploadDelete: 'حذف الرابط',
    uploadDeleteConfirm: 'حذف رابط الإضافة؟ يتوقف فوراً، والسيرفرات المضافة تبقى.',
    uploadUnavailable: 'روابط الفحص غير مفعّلة على المنصة بعد.',
  },
  announcements: {
    title: 'الإعلانات',
    add: 'إعلان جديد',
    titleField: 'العنوان',
    body: 'الرسالة',
    severity: 'الأهمية',
    info: 'معلومة',
    warning: 'تحذير',
    critical: 'حرج',
    audience: 'الجمهور',
    CUSTOMERS: 'عملاء التطبيق',
    MERCHANTS: 'التجار',
    target: 'التاجر',
    allMerchants: 'كل التجار',
    startsAt: 'يبدأ',
    endsAt: 'ينتهي',
    deleteConfirm: 'حذف هذا الإعلان؟',
  },
  overview: {
    title: 'نظرة عامة على المنصة',
    tenants: 'التجار',
    tenantsHint: 'النشطون: {{active}} · الموقوفون: {{suspended}}',
    testStores: 'متاجر التجربة غير محسوبة في هذه الأرقام: {{stores}}.',
    merchant: 'التاجر',
    test: 'تجريبي',
    noMerchants: 'لا يوجد تجار بعد.',
    cellsHint: 'كل رقم يُقرأ: المشتركون · الأجهزة.',
    hostsDown: 'سيرفرات متوقفة',
    dependencies: 'الخدمات المعتمدة',
    database: 'قاعدة البيانات',
    redis: 'Redis',
    ok: 'تعمل',
    failing: 'متعطلة',
  },
  growth: {
    newToday: 'مشتركون جدد اليوم',
    newMonth: 'مشتركون جدد (30 يومًا)',
    newHint: 'أجهزة جديدة: {{devices}}',
    downloadsToday: 'تحميلات اليوم',
    downloadsMonth: 'تحميلات (30 يومًا)',
    updatesHint: 'تحديثات من داخل التطبيق: {{updates}}',
    definition:
      'المشترك الجديد حساب لدى المزوّد يسجّل الدخول في متجر لأول مرة. الجهاز الجديد أول دخول للمشترك على شاشة أو جوال آخر. التحميلات هي تحميل ملف APK من المتصفح أو تطبيق Downloader، وكل جهاز يُحسب مرة واحدة في اليوم؛ تثبيتات Google Play والآيفون غير محسوبة.',
    downloadsSince: 'التحميلات تُحسب منذ {{day}}.',
    downloadsNone: 'لم يُحسب أي تحميل بعد.',
    dailyTitle: 'المشتركون الجدد يوميًا',
    dailyTable: 'المشتركون والأجهزة الجديدة والتحميلات يوميًا',
    newSubscribers: 'مشتركون جدد',
    newDevices: 'أجهزة جديدة',
    downloads: 'التحميلات',
    updates: 'تحديثات من داخل التطبيق',
    rankingTitle: 'التجار حسب المشتركين الجدد',
    rankingDescription:
      'المشتركون الذين سجّلوا الدخول بكود كل متجر لأول مرة، والأكثر في آخر 30 يومًا أولًا.',
    today: 'اليوم',
    allTime: 'الكل',
    share: 'النسبة من 30 يومًا',
  },
  usage: {
    sections: 'أقسام التقرير',
    now: 'الآن',
    usage: 'الاستخدام',
    technical: 'التشغيل',
    growth: 'النمو',
    merchants: 'التجار',
    system: 'النظام',
    settings: 'الإعدادات',
    features: 'الميزات',
    security: 'الأمان',
    online: 'متصل الآن',
    today: 'نشط اليوم',
    last7Days: 'آخر 7 أيام',
    last30Days: 'آخر 30 يومًا',
    audienceHint: 'مشتركين · الأجهزة: {{devices}}',
    subscribers: 'المشتركون',
    devices: 'الأجهزة',
    definition:
      'المشترك هو حساب واحد عند المزوّد. الجهاز هو شاشة أو جوال واحد لهذا المشترك، وإعادة تثبيت التطبيق عليه لا تجعله جهازًا جديدًا. "متصل الآن" يعني أن التطبيق كان مفتوحًا خلال آخر 5 دقائق.',
    dailyTitle: 'المشتركون يوميًا',
    dailyDescription: 'آخر 30 يومًا، والأيام حسب توقيت {{timeZone}}.',
    dailyTable: 'المشتركون والأجهزة في كل يوم',
    day: 'اليوم',
    platformsTitle: 'الأجهزة حسب النوع',
    platformsDescription: 'الأجهزة المستخدمة خلال آخر 30 يومًا.',
    versionsTitle: 'إصدارات التطبيق',
    versionsDescription: 'آخر إصدار استخدمه كل جهاز خلال آخر 30 يومًا.',
    version: 'الإصدار',
    noActivity: 'لم يستخدم أحد التطبيق خلال آخر 30 يومًا.',
    devicesInUse: 'الأجهزة المسجّل دخولها',
    devicesInUseHint: '{{used}} من {{limit}} تسمح بها الباقة',
    blocked: 'الأجهزة المحظورة',
    healthyHosts: 'السيرفرات السليمة',
    hostsDown: '{{count}} متعطلة',
    hostsUnchecked: '{{count}} غير مفحوصة',
    hostsDisabled: '{{count}} موقوفة',
    logins: 'عمليات دخول ناجحة (24 ساعة)',
    loginFailures: 'محاولات دخول فاشلة (24 ساعة)',
    loginFailuresHint: 'الفاشلة: {{failed}}',
  },
  errors: {
    VALIDATION_FAILED: 'بعض الحقول غير صحيحة.',
    UNAUTHENTICATED: 'يرجى تسجيل الدخول.',
    FORBIDDEN: 'ليست لديك صلاحية لهذا الإجراء.',
    NOT_FOUND: 'غير موجود.',
    CONFLICT: 'موجود مسبقًا أو تم تعديله من شخص آخر.',
    RATE_LIMITED: 'محاولات كثيرة. انتظر قليلًا ثم أعد المحاولة.',
    INVALID_CREDENTIALS: 'البريد الإلكتروني أو كلمة المرور غير صحيحة.',
    INVALID_CODE: 'الرمز غير صحيح. تأكد من ضبط الوقت في جوالك وحاول مرة أخرى.',
    ACCOUNT_LOCKED: 'محاولات فاشلة كثيرة. الحساب مقفل مؤقتًا.',
    ACCOUNT_EXPIRED: 'انتهت صلاحية الحساب.',
    ACCOUNT_DISABLED: 'هذا الحساب معطّل.',
    DEVICE_LIMIT_REACHED: 'تم الوصول للحد الأقصى من الأجهزة.',
    DEVICE_BLOCKED: 'هذا الجهاز محظور.',
    SESSION_REVOKED: 'تم إنهاء جلستك.',
    TENANT_SUSPENDED: 'حساب التاجر موقوف.',
    TENANT_EXPIRED: 'انتهى اشتراك التاجر.',
    MAINTENANCE: 'الخدمة تحت الصيانة.',
    PROVIDER_UNAVAILABLE: 'سيرفر IPTV لا يستجيب.',
    PROVIDER_NOT_CONFIGURED: 'لم يتم إعداد سيرفر IPTV.',
    UNSUPPORTED_CONTENT: 'هذا المحتوى غير مدعوم.',
    UPDATE_REQUIRED: 'يلزم تحديث التطبيق.',
    PLAN_LIMIT_REACHED: 'تم الوصول لحد الباقة.',
    FEATURE_DISABLED: 'هذه الميزة غير متاحة في باقتك.',
    INTERNAL: 'حدث خطأ. حاول مرة أخرى.',
    NETWORK: 'تعذّر الوصول إلى الخادم. تحقق من اتصالك.',
  },
  validation: {
    required: 'هذا الحقل مطلوب.',
    invalid: 'قيمة غير صحيحة.',
    email: 'أدخل بريدًا إلكترونيًا صحيحًا.',
    url: 'أدخل عنوانًا كاملًا يبدأ بـ http:// أو https://',
    color: 'استخدم لونًا مثل #1A2B3C.',
    semver: 'استخدم إصدارًا مثل 1.4.0.',
    tooShort: 'قصير جدًا.',
    tooLong: 'طويل جدًا.',
    number: 'أدخل رقمًا.',
    range: 'أدخل رقمًا صحيحًا من {{min}} إلى {{max}}.',
  },
};
